import { Component, ElementRef } from '@angular/core';
import { RoutingState } from './SharedComponents/RoutingState';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //title = 'app';
  constructor(routingState: RoutingState, private title: Title, private _elementRef: ElementRef) {
    routingState.loadRouting();
    this.title.setTitle('Academy Management Tool');
    
  }

  ngAfterViewInit() {

    this._elementRef.nativeElement.removeAttribute("ng-version");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts